// Surface helpers. The React bundle runs on app / visitor / tenants / admin —
// the surface is determined at runtime by hostname (or build-time env flag).

export const isAdminSurface = (hostname: string, buildTarget = process.env.REACT_APP_BUILD_TARGET): boolean =>
  buildTarget === 'admin'
  || hostname.startsWith('admin.')
  || hostname.startsWith('shadow.admin.');

export const IS_ADMIN_SURFACE = isAdminSurface(
  typeof window !== 'undefined' ? window.location.hostname : '',
);

export const IS_VISITOR_SURFACE = typeof window !== 'undefined' && (
  window.location.hostname === 'visitor.intrlock.io'
  || window.location.hostname === 'shadow.visitor.intrlock.io'
  || window.location.hostname === 'shadow.visitor.localhost'
);

export const IS_VISITOR_PASS_SURFACE = typeof window !== 'undefined' && (
  window.location.hostname === 'visitorpass.intrlock.io'
  || window.location.hostname === 'shadow.visitorpass.intrlock.io'
  || window.location.hostname === 'shadow.visitorpass.localhost'
);

export const IS_TENANT_SURFACE = typeof window !== 'undefined' && (
  window.location.hostname === 'tenants.intrlock.io'
  || window.location.hostname === 'shadow.tenants.intrlock.io'
  || window.location.hostname === 'shadow.tenants.localhost'
);

export const IS_SHADOW_SURFACE =
  typeof window !== 'undefined' && window.location.hostname.startsWith('shadow.');

const INTRLOCK_DOMAIN = 'intrlock.io';

export const apiOrigin = (): string =>
  IS_SHADOW_SURFACE
    ? `https://shadow.api.${INTRLOCK_DOMAIN}`
    : (process.env.REACT_APP_API_URL || `https://api.${INTRLOCK_DOMAIN}`);

export const visitorOrigin = (): string =>
  process.env.REACT_APP_VISITOR_URL
  || `https://${IS_SHADOW_SURFACE ? 'shadow.visitor' : 'visitor'}.${INTRLOCK_DOMAIN}`;
